import { createFileRoute } from "@tanstack/react-router";
import { BlueprintPage } from "../pages/blueprint";

export const Route = createFileRoute("/")({
  component: () => <BlueprintPage />,
});
